import React, { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";

function TitleMedium5() {
  const { translate } = useContext(LanguageContext);
  return (
    <div
      className="title-line-medium"
      style={{
        width: "90%",
        marginLeft: 40,
        marginBottom: 6,
        display: "flex",
        alignItems: "center",
        padding: "0 10px",
        boxSizing: "border-box",
        color: "#6b7280",
        fontWeight: 600,
        fontSize: 12,
      }}
    >
      <div
        style={{
          flex: "0 0 28%",
          paddingLeft: 5,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {translate("GoogleEmail")}
      </div>
      <div
        style={{
          flex: "0 0 22%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          paddingLeft: "10px",
        }}
      >
        {translate("UserName")}
      </div>
      <div
        style={{
          flex: "0 0 18%",
          textAlign: "left",
          paddingLeft: "10px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {translate("UserRole")}
      </div>
      <div
        style={{
          flex: "0 0 18%",
          textAlign: "left",
          paddingLeft: "10px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {translate("PhoneNumber")}
      </div>
      <div
        style={{
          flex: "0 0 14%",
          display: "flex",
          justifyContent: "flex-end",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          paddingRight: "10px",
        }}
      >
        {translate("Actions")}
      </div>
    </div>
  );
}

export default TitleMedium5;
